"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _connectOnboardingTourDisplay = _interopRequireDefault(require("crm_internal/onboarding/connectOnboardingTourDisplay"));

var _profileOnboardingTourConfig = _interopRequireDefault(require("crm_ui/config/onboarding/profileOnboardingTourConfig"));

var _default = (0, _connectOnboardingTourDisplay.default)(_profileOnboardingTourConfig.default);

exports.default = _default;
module.exports = exports.default;